import { uri } from 'utils';

import { LISTING_PAGE_URL_PARAMETER } from '../constants';

/**
 * @param {string} url
 * @returns {number}
 */
const getCurrentPageFromURL = url => {
    const urlParameter = uri.getParams(url)[LISTING_PAGE_URL_PARAMETER];

    if (!urlParameter) {
        return null;
    }

    const sanitized = parseInt(urlParameter, 10);

    if (Number.isNaN(sanitized)) {
        return null;
    }

    return sanitized;
};

export default getCurrentPageFromURL;
